import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges ,OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ItemDetail } from '../../models/item.model'

@Component({
  selector: 'app-multiselect-dropdown',
  templateUrl: './multiselect-dropdown.component.html',
  styleUrls: ['./multiselect-dropdown.component.css']
})
export class MultiSelectDropdownComponent implements OnInit{

  @Input() list:any[]; 
    
    @Output() shareCheckedList = new EventEmitter();
    @Output() shareIndividualCheckedList = new EventEmitter();
    @Output() shareCheckedNameValueList = new EventEmitter();
    
    
    checkedList : any[];
    nameValueList : ItemDetail[];
    currentSelected : {};
    showDropDown: boolean;

  constructor() {
    this.checkedList = [];
    this.nameValueList = [];
   }

   ngOnInit() {
    console.log('****MultiSelectDropdownComponent****');
  }
    getSelectedValue(status:Boolean,item_id:number,item_uid:string, item_text:string){
    const itemDetail: ItemDetail = {
      item_id: item_id,item_uid: item_uid,item_text: item_text      
    };
    if(status){
      this.checkedList.push(item_text);
      
      this.nameValueList.push(itemDetail);  
    }else{
        var index = this.checkedList.indexOf(item_text);
        this.checkedList.splice(index,1);

        var index1 = this.nameValueList.indexOf(itemDetail);
        this.nameValueList.splice(index1,1);
    }
    
    this.currentSelected = {checked : status,name:item_text};

    //share checked list
    this.shareCheckedlist();
    
    //share individual selected item
    this.shareIndividualStatus();

    this.shareCheckedNameValuelist();
  }
  shareCheckedlist(){
        this.shareCheckedList.emit(this.checkedList);
  }
  shareIndividualStatus(){
      this.shareIndividualCheckedList.emit(this.currentSelected);
  }
  shareCheckedNameValuelist(){
    this.shareCheckedNameValueList.emit(this.nameValueList);
}

}
